export default {"src":"/_next/static/image/public/plus.8871621d1d5ba8d0913584dafdd2c94c.svg","height":26,"width":26};